var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loader === true),expression:"loader === true"}],attrs:{"id":"loading"}},[_c('vue-loaders-pacman',{attrs:{"scale":"1.5","color":"#27397c"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }